import React, { useEffect, useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function WhatsAppButton() {
  const [showTooltip, setShowTooltip] = useState(false);
  const whatsappUrl = 'https://wa.me/5493813588908?text=Hola%21%20te%20escribo%20desde%20la%20pagina%20del%20%22Manual%20Academico%20de%20Lengua%20y%20Literatura%22%2C%20me%20gustaria%20recibir%20mas%20informacion';
  useEffect(() => {
    // Show tooltip after 2 seconds initially
    const initialTimer = setTimeout(() => {
      setShowTooltip(true);
    }, 2000);
    return () => clearTimeout(initialTimer);
  }, []);
  const handleDismiss = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShowTooltip(false);
    // Reappear after 30 seconds
    setTimeout(() => {
      setShowTooltip(true);
    }, 30000);
  };
  return <div className="fixed bottom-6 right-6 z-50 flex items-center" data-id="element-236">
      <AnimatePresence data-id="element-237">
        {showTooltip && <motion.div initial={{
        opacity: 0,
        x: 20,
        scale: 0.9
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: 10,
        scale: 0.9
      }} className="absolute right-full mr-4 bg-white text-[#1F3A5F] px-4 py-3 rounded-xl shadow-xl border border-gray-100 text-sm font-medium w-56 hidden md:flex items-start gap-2" data-id="element-238">
            <span className="flex-1" data-id="element-239">
              Si tenés dudas, ¡mandanos un WhatsApp!
            </span>
            <button onClick={handleDismiss} className="text-gray-400 hover:text-gray-600 mt-0.5 p-1 bg-gray-50 rounded-full" data-id="element-240">
              <X size={14} data-id="element-241" />
            </button>
            {/* Triangle pointer */}
            <div className="absolute top-1/2 -translate-y-1/2 -right-2 w-0 h-0 border-y-8 border-y-transparent border-l-8 border-l-white drop-shadow-md" data-id="element-242" />
          </motion.div>}
      </AnimatePresence>

      <motion.a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="bg-[#25D366] hover:bg-[#1EBE5D] text-white rounded-full p-4 shadow-2xl transition-all relative z-10" whileHover={{
      scale: 1.1
    }} whileTap={{
      scale: 0.95
    }} animate={{
      boxShadow: ['0 0 0 0 rgba(37, 211, 102, 0.7)', '0 0 0 20px rgba(37, 211, 102, 0)']
    }} transition={{
      duration: 1.5,
      repeat: Infinity,
      repeatType: 'loop'
    }} data-id="element-243">
        <MessageCircle size={32} data-id="element-244" />
      </motion.a>
    </div>;
}